import React, { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { EmojiTitleButtonLoader } from '@confluence/emoji-title/entry-points/EmojiTitleButton';
import { fg } from '@confluence/feature-gating';

import type { EmojiButtonProps } from './titleareaContentComponentsTypes';

const emojiTitleHoverButtonBoxStylesOpacity1 = xcss({
	opacity: 1,
});

const emojiTitleHoverButtonBoxStylesOpacity0 = xcss({
	opacity: 0,
});

export const EmojiButton = ({
	contentId,
	userOffline,
	isTitleDisabled,
	isUnpublishedDraft,
	shouldShowHoverButton,
	isCoverPictureModalOpen,
	setSelectedEmoji,
	onEmojiPickerLoaded,
	onUpdateStartEmoji,
	onUpdateEndEmoji,
	floatingToolbarButtonStyle,
	onEmojiPickerClose,
	contentType,
}: EmojiButtonProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleOnMouseEnter = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'hovered',
				source: 'EmojiTitleSection',
				actionSubject: 'pageTitle',
				actionSubjectId: 'emojiButton',
				attributes: {
					element: 'div',
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	const handleOnMouseLeave = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'not:hovered',
				source: 'EmojiTitleSection',
				actionSubject: 'pageTitle',
				actionSubjectId: 'emojiButton',
				attributes: {
					element: 'div',
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<Box
			xcss={
				!fg('confluence_title_toolbar_ttvc_fix')
					? [
							shouldShowHoverButton || isCoverPictureModalOpen
								? emojiTitleHoverButtonBoxStylesOpacity1
								: emojiTitleHoverButtonBoxStylesOpacity0,
						]
					: undefined
			}
			testId="emoji-title-hover-button-wrapper"
			onMouseEnter={handleOnMouseEnter}
			onMouseLeave={handleOnMouseLeave}
		>
			<EmojiTitleButtonLoader
				isUnpublishedDraft={isUnpublishedDraft}
				setSelectedEmoji={setSelectedEmoji}
				onEmojiPickerLoaded={onEmojiPickerLoaded}
				disableEmoji={userOffline}
				contentId={contentId}
				isTitleDisabled={isTitleDisabled}
				onUpdateStartEmoji={onUpdateStartEmoji}
				onUpdateEndEmoji={onUpdateEndEmoji}
				floatingToolbarButtonStyle={floatingToolbarButtonStyle}
				onEmojiPickerClose={onEmojiPickerClose}
				contentType={contentType}
			/>
		</Box>
	);
};
